import * as yup from "yup";
import { ERRORS } from "../constants/errors";

export const addMetaInfoValidation = yup.object().shape({
    page: yup.string().required(ERRORS.PAGE_REQUIRED),
    meta_title: yup.string().required(ERRORS.META_TITLE_REQUIRED),
    meta_description: yup.string().required(ERRORS.META_DESCRIPTION_REQUIRED),
});

export const updateMetaInfoValidation = yup.object().shape({
    meta_title: yup.string().required(ERRORS.META_TITLE_REQUIRED),
    meta_description: yup.string().required(ERRORS.META_DESCRIPTION_REQUIRED),
});